import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TipoDescodificadorService } from 'src/services/tipo-descodificador.service';
import { PermissoesService } from 'src/services/permissoes.service';

@Component({
    selector: 'app-tipo-descodificador',
    templateUrl: './tipo-descodificador.component.html',
    styleUrls: ['./tipo-descodificador.component.scss'],
    standalone: false
})
export class TipoDescodificadorComponent implements OnInit {
  data: any[] = []
  displayModal: boolean = false
  loading: boolean = false
  form: FormGroup;
  direitoInserir: boolean = false;
  direitoEditar: boolean = false;

  constructor(
    protected _tdService: TipoDescodificadorService,
    protected _formBuilder: FormBuilder,
    protected permissaoService: PermissoesService,
  ) { }


  ngOnInit(): void {
    this.direitoInserir = this.permissaoService.can('descodificadores_inserir');
    this.direitoEditar = this.permissaoService.can('descodificadores_editar');
    this.index()
  }
  
  index(){
  this._tdService.index().subscribe(json => {
    this.data = json
  })
  }

  openNew(){
    this.displayModal = true
  }
  }